export const Tags = Object.freeze({
  REACT: "React",
  JS: "Javascript",
  TS: "Typescript",
  SQL: "SQL",
  HTML: "HTML",
  CSS: "CSS",
  ASYNC: "Async",
  GIT: "Git",
  SASS: "SASS",
  FIREBASE: "Firebase",
  PYTHON: "Python",
  FLASK: "Flask",
  KOTLIN: "Kotlin",
  JC: "Jetpack Compose",
  CPP: "C++",
  CMD: "Command Line",
  AUTH: "Auth",
  VERCEL: "Vercel",
  LLVM: "LLVM",
  DOCKER: "Docker",
  JENKINS: "Jenkins",
  MT: "Multithreading",
  ASM: "Assembly",
  C: "C",
  TRANSFORMERS: "Transformers",
  LLAMA: "LlamaLLM",
  PANDAS: "Pandas",
  MATPLOTLIB: "Matplotlib",
  Encoding: "Video Encoding",
  OpenCL: "OpenCL",
  OpenGL: "OpenGL",
});
